import { findMatchingThreshold } from './find-matching-threshold.js';
import { getThresholdIndicators } from './get-threshold-indicators.js';
import { LegendItem } from '../../../core/components/legend/categorical/types/legend.js';
import { ThresholdMetadata } from '../types/meter-bar-chart-internal.js';

export function buildThresholds(
  value: number,
  min: number,
  max: number,
  width: number,
  thresholdsConfig?: ThresholdMetadata,
) {
  const matchingThreshold =
    thresholdsConfig !== undefined
      ? findMatchingThreshold(value, thresholdsConfig.data, min)
      : undefined;

  const thresholdIndicators =
    thresholdsConfig !== undefined
      ? getThresholdIndicators(thresholdsConfig.data, min, max, width)
      : [];

  const legendItems: LegendItem[] =
    thresholdsConfig !== undefined
      ? thresholdsConfig.data.map((threshold, index) => {
          const name = threshold.name ?? `Threshold ${index + 1}`;

          return {
            id: `item-${name}-${index}`,
            name,
            color: { Default: threshold.color },
          };
        })
      : [];

  return { matchingThreshold, thresholdIndicators, legendItems };
}
